import { Routes } from '@angular/router';
import { cockpitFilterGuard } from './cockpit/shared/guards/cockpit-filter.guard';
import { TestResolver } from './components/test-data-grid/resolvers/test.resolver';
import { AdminGuardComponent } from './core/components/admin-guard/admin-guard.component';
import { AuthGuard } from './core/guard/auth.guard';
import { NotAuthGuard } from './core/guard/notAuth.guard';
import { MailPreferenceResolver } from './core/resolvers/mail-preference.resolver';
import { FourOFourComponent } from './four-o-four/four-o-four.component';

export const routes: Routes = [
  {
    path: '',
    canActivate: [NotAuthGuard],
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
    title: 'Paddock One - Authentification',
  },
  {
    path: 'clear-cache',
    loadComponent: () => import('./components/clear-cache/clear-cache.component').then((m) => m.ClearCacheComponent),
    title: 'Paddock One - Clear Cache',
  },
  {
    path: 'profile',
    canActivate: [AuthGuard],
    loadComponent: () => import('./components/profile/profile.component').then((m) => m.ProfileComponent),
    title: 'Paddock One - Profile',
    resolve: {
      mailPreference: MailPreferenceResolver,
    },
    data: {
      breadcrumb: {
        label: 'Profile',
        url: '/profile',
      },
    },
  },
  {
    path: 'portail',
    canActivate: [AuthGuard],
    loadChildren: () => import('./gate/gate-routing.module').then((m) => m.GateRoutingModule),
    title: 'Paddock One - Portail',
    data: {
      breadcrumb: {
        label: 'Portail',
        url: '/portail',
      },
    },
  },
  {
    path: 'cahier-de-liaison',
    canActivate: [AuthGuard],
    loadChildren: () => import('./cahier-de-liaison/cahier-de-liaison-routing.module').then((m) => m.CahierDeLiaisonRoutingModule),
    title: 'Paddock One - Cahier de liaison',
    data: {
      breadcrumb: {
        label: 'Cahier de liaison',
        url: '/cahier-de-liaison',
      },
    },
  },
  {
    path: 'outils-marketing',
    canActivate: [AuthGuard],
    loadChildren: () => import('./tools-marketing/tools-marketing-routing.modules').then((m) => m.ToolsMarketingRoutingModule),
    title: 'Paddock One - Outils Marketing',
    data: {
      breadcrumb: {
        label: 'Outils Marketing',
        url: '/outils-marketing',
      },
    },
  },
  {
    path: 'marge',
    canActivate: [AuthGuard],
    loadChildren: () => import('./marge/marge-routing.module').then((m) => m.MargeRoutingModule),
    title: 'Paddock One - Marge 2',
    data: {
      breadcrumb: {
        label: 'Marge 2',
        url: '/marge',
      },
    },
  },
  {
    path: 'post-liv',
    canActivate: [AuthGuard],
    loadChildren: () => import('./post-liv/post-liv-routing.module').then((m) => m.PostLivRoutingModule),
    title: 'Paddock One - Post Liv',
    data: {
      breadcrumb: {
        label: 'Post Liv',
        url: '/post-liv',
      },
    },
  },
  {
    path: 'quotidien',
    canActivate: [AuthGuard],
    loadChildren: () => import('./quotidien/quotidien-routing.module').then((m) => m.QuotidienRoutingModule),
    title: 'Paddock One - Quotidien',
    data: {
      breadcrumb: {
        label: 'Quotidien',
        url: '/quotidien',
      },
    },
  },
  {
    path: 'admin-check/:path',
    canActivate: [AuthGuard],
    component: AdminGuardComponent,
  },
  {
    path: 'requeteur',
    loadChildren: () => import('./requeteur/requeteur.routing.module').then((m) => m.RequeteurRoutingModule),
    title: 'Paddock One - Requêteur',
    canActivate: [AuthGuard],
    data: {
      breadcrumb: {
        label: 'Requêteur',
        url: '/requeteur',
      },
    },
  },
  {
    path: 'campagne',
    loadChildren: () => import('./campagne/campagne.routing-module').then((m) => m.CampagneRoutingModule),
    title: 'Paddock One - Campagne',
    canActivate: [AuthGuard],
    data: {
      breadcrumb: {
        label: 'Campagne',
        url: '/campagne',
      },
    },
  },
  {
    path: 'vd',
    loadChildren: () => import('./vd/vd-routing.module').then((m) => m.VdRoutingModule),
    title: 'Paddock One - Vd',
    canActivate: [AuthGuard],
    data: {
      breadcrumb: {
        label: 'VD',
        url: '/vd',
      },
    },
  },
  {
    path: 'vo',
    loadChildren: () => import('./vo/vo-routing.module').then((m) => m.VoRoutingModule),
    title: 'Paddock One - Vo',
    canActivate: [AuthGuard],
    data: {
      breadcrumb: {
        label: 'VO',
        url: '/vo',
      },
    },
  },
  {
    path: 'essai-pret',
    loadChildren: () => import('./essai-pret/essai-pret-routing.module').then((m) => m.EssaiPretRoutingModule),
    title: 'Paddock One - Essai/Pret',
    canActivate: [AuthGuard],
    data: {
      breadcrumb: {
        label: 'Essai/Pret',
        url: '/essai-pret',
      },
    },
  },
  {
    path: 'appel-apv',
    loadChildren: () => import('./appel-apv/appel-apv-routing.module').then((m) => m.AppelApvRoutingModule),
    title: 'Paddock One - Appel APV',
    canActivate: [AuthGuard],
    data: {
      breadcrumb: {
        label: 'Appel APV',
        url: '/appel-apv',
      },
    },
  },
  {
    path: 'recrutement',
    loadChildren: () => import('./recrutement/recrutement-routing.module').then((m) => m.RecrutementRoutingModule),
    title: 'Paddock One - Recrutement',
    canActivate: [AuthGuard],
    data: {
      breadcrumb: {
        label: 'Recrutement',
        url: '/recrutement',
      },
    },
  },
  {
    path: 'formation',
    loadChildren: () => import('./formation/formation-routing.module').then((m) => m.FormationRoutingModule),
    title: 'Paddock One - Formation',
    canActivate: [AuthGuard],
    data: {
      breadcrumb: {
        label: 'Formation',
        url: '/formation',
      },
    },
  },
  {
    path: 'optiliv',
    loadChildren: () => import('./optiliv/optiliv-routing.module').then((m) => m.OptilivRoutingModule),
    title: 'Paddock One - Optiliv',
    canActivate: [AuthGuard],
    data: {
      breadcrumb: {
        label: 'Optiliv',
        url: '/optiliv',
      },
    },
  },
  {
    path: 'objectifs',
    loadChildren: () => import('./objectif/objectif-routing.module').then((m) => m.ObjectifRoutingModule),
    title: 'Paddock One - Objectifs',
    canActivate: [AuthGuard],
    data: {
      breadcrumb: {
        label: 'Objectifs',
        url: '/objectifs',
      },
    },
  },
  {
    path: 'carriere',
    loadChildren: () => import('./carriere/carriere-routing.module').then((m) => m.CarriereRoutingModule),
    title: 'Paddock One - Carrière',
    canActivate: [AuthGuard],
    data: {
      breadcrumb: {
        label: 'Carrière',
        url: '/carriere',
      },
    },
  },
  {
    path: 'perfco',
    loadChildren: () => import('./perf-co/perf-co-routing.module').then((m) => m.PerfCoRoutingModule),
    title: 'Paddock One - Perf Co',
    canActivate: [AuthGuard],
    data: {
      breadcrumb: {
        label: 'PerfCo',
        url: '/perfco',
      },
    },
  },
  {
    path: 'piilot',
    loadChildren: () => import('./piilot/piilot-routing-module').then((m) => m.PiilotRoutingModule),
    title: 'Paddock One - Piilot',
    canActivate: [AuthGuard],
    data: {
      breadcrumb: {
        label: 'Piilot',
        url: '/piilot',
      },
    },
  },
  {
    path: 'suivi-creance',
    loadChildren: () => import('./suivi-creance/suivi-creance-routing.module').then((m) => m.SuiviCreanceRoutingModule),
    title: 'Paddock One - Créance',
    canActivate: [AuthGuard],
    data: {
      breadcrumb: {
        label: 'Créance',
        url: '/suivi-creance',
      },
    },
  },
  {
    path: 'cockpit',
    loadChildren: () => import('./cockpit/cockpit-routing.module').then((m) => m.CockpitRoutingModule),
    title: 'Paddock One - Cockpit',
    canActivate: [AuthGuard],
    canActivateChild: [cockpitFilterGuard],
    data: {
      breadcrumb: {
        label: 'Cockpit',
        url: '/cockpit',
      },
    },
  },
  {
    path: 'calendrier',
    loadComponent: () => import('./components/calendar/calendar').then((m) => m.CalendarComponent),
    title: 'Paddock One - Calendrier',
    canActivate: [AuthGuard],
    data: {
      breadcrumb: {
        label: 'Calendrier',
        url: '/calendrier',
      },
    },
  },
  {
    path: 'plan-de-lancement',
    loadChildren: () => import('./plan-de-lancement/plan-de-lancement-routing.module').then((m) => m.PlanDeLancementRoutingModule),
    title: 'Paddock One - Plan de Lancement',
    canActivate: [AuthGuard],
    data: {
      breadcrumb: {
        label: 'Plan de Lancement',
        url: '/plan-de-lancement',
      },
    },
  },
  {
    path: 'recrutement-formation',
    loadChildren: () => import('./recrutement-formation/recrutement-formation-routing-module').then((m) => m.RecrutementFormationRoutingModule),
    title: 'Paddock One - Recrutement Formation',
    canActivate: [AuthGuard],
    data: {
      breadcrumb: {
        label: 'Recrutement Formation',
        url: '/recrutement-formation',
      },
    },
  },
  {
    path: 'or-snap',
    loadChildren: () => import('./or-snap/photo-or-routing-module').then((m) => m.PhotoOrRoutingModule),
    title: 'Paddock One - OR Snap',
    canActivate: [AuthGuard],
    data: {
      breadcrumb: {
        label: 'OR Snap',
        url: '/or-snap',
      },
    },
  },

  {
    path: 'suivi-prime',
    loadChildren: () => import('./suivi-prime/suivi-prime-routing.module').then((m) => m.SuiviPrimeRoutingModule),
    title: 'Paddock One - Suivi Prime',
    canActivate: [AuthGuard],
    data: {
      breadcrumb: {
        label: 'Suivi Prime',
        url: '/suivi-prime',
      },
    },
  },
  {
    path: 'easy-frais',
    loadChildren: () => import('./easy-frais/easy-frais-routing.module').then((m) => m.EasyFraisRoutingModule),
    title: 'Paddock One - Easy frais',
    canActivate: [AuthGuard],
    data: {
      breadcrumb: {
        label: 'Easy frais',
        url: '/easy-frais',
      },
    },
  },
  {
    path: 'test-data-grid',
    loadComponent: () => import('./components/test-data-grid/test-data-grid').then((m) => m.TestDataGridComponent),
    title: 'Paddock One - Test Data Grid',
    resolve: {
      test: TestResolver,
    },
    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
    data: {
      breadcrumb: {
        label: 'Test Data Grid',
        url: '/test-data-grid',
      },
    },
  },
  {
    path: 'siv-tracker',
    loadChildren: () => import('./siv-tracker/siv-tracker-routing-module').then((m) => m.SivTrackerRoutingModule),
    title: 'Paddock One - SIV Tracker',
    canActivate: [AuthGuard],
    data: {
      breadcrumb: {
        label: 'SIV Tracker',
        url: '/siv-tracker',
      },
    },
  },
  {
    path: '**',
    component: FourOFourComponent,
    title: 'Paddock One - 404',
    data: {
      breadcrumb: {
        label: 'Page introuvable',
        url: null,
      },
    },
  },
];
